import { useQuery } from '@tanstack/react-query';
import { fetchMilitaryLocations, type MilitaryLocation } from '@/services/map/layers/militaryLocationsLayer';

/**
 * React Query hook for fetching military locations
 * Enabled only when a polygon is selected and getToken is available
 */
export const useMilitaryLocationsQuery = (getToken: (() => Promise<string>) | undefined, polygonWkt: string | null) => {
  return useQuery<MilitaryLocation[], Error>({
    queryKey: ['militaryLocations', { polygonWkt }],
    enabled: !!polygonWkt && !!getToken,
    queryFn: async () => {
      if (!getToken) {
        throw new Error('getToken is required to fetch military locations');
      }
      return fetchMilitaryLocations(getToken);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
